// @flow

import * as React from 'react';
import { compose, withState } from 'recompose';
import { connect } from 'react-redux';
import Radium from 'radium';
import firebase from 'firebase/app';

import { createEmployee } from 'actions/employees';

import {
  Card,
  CardHeader,
  CardBlock,
  FormGroup,
  Button,
  Input,
  Alert,
} from 'reactstrap';

type Props = {
  onCreate: Object => Promise<void>,

  // recompose
  loading: boolean,
  onLoadingChange: (loading: boolean) => void,
  firstname: string,
  onFirstnameChange: (firstname: string) => void,
  lastname: string,
  onLastnameChange: (lastname: string) => void,
  email: string,
  onEmailChange: (email: string) => void,
  password: string,
  onPasswordChange: (password: string) => void,

  // redux
  error: ?string,
  createEmployee: typeof createEmployee,
};

class NewEmployee extends React.Component<Props> {
  _onCreateEmployee = async () => {
    const {
      onLoadingChange,
      firstname,
      lastname,
      email,
      password,
      onFirstnameChange,
      onLastnameChange,
      onEmailChange,
      onPasswordChange,
    } = this.props;

    try {
      onLoadingChange(true);
      const createEmployee = firebase
        .functions()
        .httpsCallable('createEmployee');
      await createEmployee({
        displayName: `${firstname} ${lastname}`,
        email,
        password,
      });
      onLoadingChange(false);

      onFirstnameChange('');
      onLastnameChange('');
      onEmailChange('');
      onPasswordChange('');
    } catch (error) {
      onLoadingChange(false);
    }
  };

  render() {
    const {
      error,
      loading,
      firstname,
      onFirstnameChange,
      lastname,
      onLastnameChange,
      email,
      onEmailChange,
      password,
      onPasswordChange,
    } = this.props;

    return (
      <Card style={styles.root}>
        <CardHeader style={styles.title}>Neuen Mitarbeiter anlegen</CardHeader>
        <CardBlock>
          <FormGroup>
            <Input
              type="textfield"
              placeholder="Vorname"
              value={firstname}
              onChange={event => onFirstnameChange(event.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="textfield"
              placeholder="Nachname"
              value={lastname}
              onChange={event => onLastnameChange(event.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="textfield"
              placeholder="Emailadresse"
              autoComplete="new-password"
              value={email}
              onChange={event => onEmailChange(event.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="password"
              placeholder="Passwort"
              autoComplete="new-password"
              value={password}
              onChange={event => onPasswordChange(event.target.value)}
            />
          </FormGroup>
          {!!error && (
            <Alert color="danger">
              <span>{error}</span>
            </Alert>
          )}
          {loading ? (
            <div>Bitte warten ...</div>
          ) : (
            <Button
              color="primary"
              disabled={!firstname || !lastname || !email || !password}
              onClick={this._onCreateEmployee}
            >
              Mitarbeiter anlegen
            </Button>
          )}
        </CardBlock>
      </Card>
    );
  }
}

const styles = {
  root: {
    width: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
};

const mapStateToProps = ({ employees: { error } }) => ({
  error: (error && error.code) || null,
});
const mapDispatchToProps = {
  createEmployee,
};

const NewEmployeeContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('loading', 'onLoadingChange', false),
  withState('firstname', 'onFirstnameChange', ''),
  withState('lastname', 'onLastnameChange', ''),
  withState('email', 'onEmailChange', ''),
  withState('password', 'onPasswordChange', ''),
  Radium
)(NewEmployee);

export default NewEmployeeContainer;



// WEBPACK FOOTER //
// ./src/views/Employees/NewEmployee.js